import * as React from 'react';

import loadingimg from './icons/settings64.png';

export class Loading extends React.Component {
    render(){
        return ( <div className="loadingcontainer"><img className='iconaloading' src={loadingimg} alt="Caricamento" /><br/>... Caricamento ...</div>);
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/AcComponents/Loading.js